import React from 'react'

import actions from 'actions'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { basketIsPortionSizeViewVisibleChange } from 'actions/basket'
import { boxSummaryVisibilityChange, boxSummaryNext } from 'actions/boxSummary'
import { usePricing } from 'routes/Menu/domains/pricing'
import { useIsBasketComprehensionEnabled } from 'routes/Menu/hooks/useIsBasketComprehensionEnabled'
import { getUnavailableRecipeIds } from 'routes/Menu/selectors/basket'
import { getIsAuthenticated } from 'selectors/auth'
import { getBrowserType } from 'selectors/browser'
import { isMobile } from 'utils/view'

import {
  getBasketOrderId,
  getBasketRecipes,
  getBasketUsageCount,
  getNumPortions,
  shouldShowBoxSummary,
} from '../../../../selectors/basket'
import { getMenuBrowseCTAShow } from '../../../../selectors/root'
import { BoxSummaryTreatment } from '../BoxSummaryTreatment'
import { BoxSummary } from './BoxSummary'
import { restoreBoxSummaryTreatmentFocus } from './treatmentFocus'

const mapStateToProps = (state) => ({
  isMobile: isMobile(getBrowserType(state)),
  recipes: getBasketRecipes(state),
  showDetails: state.boxSummaryShow.get('show'),
  orderId: getBasketOrderId(state),
  basketCheckedOut: state.pending.get(actionTypes.BASKET_CHECKOUT),
  basketCheckoutClicked: state.pending.get(actionTypes.BASKET_CHECKOUT_CLICKED),
  menuFetchPending: state.pending.get(actionTypes.MENU_FETCH_DATA),
  hasUnavailableRecipes: Boolean(getUnavailableRecipeIds(state).size),
  orderSaveError: state.error.get(actionTypes.ORDER_SAVE),
  shouldShowBoxSummary: shouldShowBoxSummary(state),
  shouldMenuBrowseCTAShow: getMenuBrowseCTAShow(state),
  isAuthenticated: getIsAuthenticated(state),
  numRecipes: getBasketUsageCount(state),
  numPortions: getNumPortions(state),
})

export const BoxSummaryPure = (props) => {
  const {
    showDetails,
    boxDetailsVisibilityChange,
    basketIsPortionSizeViewVisibleChange: onBasketIsPortionSizeViewVisibleChange,
    basketRestorePreviousValues,
    boxSummaryNext: onBoxSummaryNext,
    numRecipes,
    numPortions,
  } = props
  const { isPending, pricing } = usePricing()
  const isBasketComprehensionEnabled = useIsBasketComprehensionEnabled()

  const detailsSurface = isBasketComprehensionEnabled ? (
    <BoxSummaryTreatment
      showDetails={showDetails}
      boxDetailsVisibilityChange={boxDetailsVisibilityChange}
      basketIsPortionSizeViewVisibleChange={onBasketIsPortionSizeViewVisibleChange}
      basketRestorePreviousValues={basketRestorePreviousValues}
      boxSummaryNext={onBoxSummaryNext}
      restoreFocusAfterClose={restoreBoxSummaryTreatmentFocus}
      numRecipes={numRecipes}
      numPortions={numPortions}
    />
  ) : null

  return (
    <BoxSummary
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      detailsSurface={detailsSurface}
      pricingPending={isPending}
      totalPrice={pricing?.total} // used for data layer tracking
    />
  )
}

BoxSummaryPure.propTypes = {
  showDetails: PropTypes.bool.isRequired,
  boxDetailsVisibilityChange: PropTypes.func.isRequired,
  basketIsPortionSizeViewVisibleChange: PropTypes.func.isRequired,
  basketRestorePreviousValues: PropTypes.func.isRequired,
  boxSummaryNext: PropTypes.func.isRequired,
  numRecipes: PropTypes.number.isRequired,
  numPortions: PropTypes.number.isRequired,
}

export const BoxSummaryContainer = connect(mapStateToProps, {
  basketIsPortionSizeViewVisibleChange,
  boxDetailsVisibilityChange: boxSummaryVisibilityChange,
  basketRestorePreviousValues: actions.basketRestorePreviousValues,
  boxSummaryNext,
})(BoxSummaryPure)
